import { useSelector } from "react-redux";
import axios, { AxiosError, AxiosResponse } from "axios";
import { Traveler } from "../../trip/objects/traveler";
import { AppState } from "../../../reducers";

type Callback = (data: TravelerCreateData[]) => Promise<Traveler[]>

type Options = {
    onTrigger: () => void,
    onSuccess: (travelers: Traveler[]) => void,
    onError: (error: AxiosError) => void,
    onFinally: () => void
}

type TravelerCreateData = {
    first_name: string,
    last_name: string,
    birth_date: string
}

export function useTravelersCreate(options: Options): Callback {
    const clientId = useSelector((state: AppState) => state.header.client_id);

    return async (data) => {
        if (clientId !== null) {
            try {
                options.onTrigger();
                const response = await makeRequest(clientId, data);
                options.onSuccess(response.data);
                return response.data;
            } catch (error: any) {
                options.onError(error);
            } finally {
                options.onFinally();
            }
        }
        return [];
    };
}

function makeRequest(
    clientId: number,
    data: TravelerCreateData[]
): Promise<AxiosResponse<Traveler[]>> {
    return axios.post(
        `${API_HREF}client/${clientId}/travelers/array_create/`,
        data,
        {
            headers: {
                'Authorization': `Token ${localStorage.getItem('token')}`,
            },
        }
    );
}